"use strict";

/* ========== CONFIG: ændr spørgsmål/point her ========== */
const QUESTIONS = [{
  id: "q1",
  text: "Kan du lugte en muggen eller jordslået lugt i boligen?",
  type: "radio",
  options: [{
    text: "Ja",
    value: 3
  }, {
    text: "Nej",
    value: 0
  }]
}, {
  id: "q2",
  text: "Har du synlige mørke eller grønne pletter på vægge, loft eller fuger?",
  type: "radio",
  options: [{
    text: "Ja",
    value: 3
  }, {
    text: "Nej",
    value: 0
  }]
}, {
  id: "q3",
  text: "Har du oplevet fugtproblemer (fx kondens, vandskade, utæt tag, kælderfugt)?",
  type: "radio",
  options: [{
    text: "Ja, for nylig",
    value: 2
  }, {
    text: "Ja, tidligere",
    value: 1
  }, {
    text: "Nej",
    value: 0
  }]
}, {
  id: "q4",
  text: "Har du eller nogen i husstanden uforklarlige symptomer som hoste, træthed, hovedpine eller irritation i øjne/næse?",
  type: "radio",
  options: [{
    text: "Ja",
    value: 2
  }, {
    text: "Nej",
    value: 0
  }]
}, {
  id: "q5",
  text: "Er der områder i hjemmet med dårlig ventilation eller hvor der sjældent luftes ud?",
  type: "radio",
  options: [{
    text: "Ja",
    value: 1
  }, {
    text: "Nej",
    value: 0
  }]
}, {
  id: "q6",
  text: "Er bygningen ældre end 30 år, eller er der udfordringer med isolering?",
  type: "radio",
  options: [{
    text: "Ja",
    value: 1
  }, {
    text: "Nej",
    value: 0
  }]
}, {
  id: "q7",
  text: "Har du tidligere haft problemer med skimmelsvamp i boligen?",
  type: "radio",
  options: [{
    text: "Ja",
    value: 2
  }, {
    text: "Nej",
    value: 0
  }]
}];

/* ========== RESULT LOGIC: point thresholds & tekster ========== */
const RESULTS = [{
  min: 0,
  max: 2,
  title: "Højest sandsynligt ikke skimmelsvamp",
  description: "Det lyder ikke som om der er tydelige tegn på skimmelsvamp lige nu. Hold øje med fugt og sørg for god ventilation. Hvis du er i tvivl, kan du altid kontakte en fagmand."
}, {
  min: 3,
  max: 6,
  title: "Muligvis skimmelsvamp",
  description: "Nogle af dine svar peger på begyndende fugt- eller skimmelproblemer. Overvej at foretage en nærmere visuel inspektion eller få en professionel vurdering."
}, {
  min: 7,
  max: 999,
  title: "Højest sandsynligt skimmelsvamp",
  description: "Dine svar tyder på et potentielt problem med skimmelsvamp. Vi anbefaler, at du kontakter en fagmand for inspektion og eventuel afhjælpning snarest."
}];
const quizContainer = document.getElementById("quiz-container");
const resultContainer = document.getElementById("quiz-result");
const resultHeader = document.getElementById("result-header");
const resultContent = document.getElementById("result-content");
const quizQuestion = document.getElementById("quiz-question");
const quizOptions = document.getElementById("quiz-options");
const nextButton = document.getElementById("next-question");
const startQuiz = document.getElementById("start-quiz");
const restartQuiz = document.getElementById("restart-quiz");
const quizContent = document.getElementById("quiz-content");
let currentQuestionIndex = 0;
let totalScore = 0;
const selectAnswer = event => {
  nextButton.disabled = false;
};
function showQuestion() {
  const question = QUESTIONS[currentQuestionIndex];
  console.log(question.text);
  quizQuestion.textContent = question.text;
  quizOptions.innerHTML = "";
  for (const option of question.options) {
    const li = document.createElement("li");
    li.className = "mb-2";
    const label = document.createElement("label");
    label.className = "flex items-center gap-3 cursor-pointer";
    const input = document.createElement("input");
    input.type = question.type;
    input.name = question.id;
    input.value = option.value;
    input.className = "form-radio h-5 w-5 text-blue-600";
    const span = document.createElement("span");
    span.textContent = option.text;
    label.appendChild(input);
    label.appendChild(span);
    li.appendChild(label);
    quizOptions.appendChild(li);
    input.addEventListener("change", selectAnswer);
  }
}
function showResults() {
  quizContent.classList.add("hidden");
  resultContainer.classList.remove("hidden");

  // Determine result based on totalScore
  let result = RESULTS.find(r => totalScore >= r.min && totalScore <= r.max);
  if (!result) {
    result = {
      title: "Resultat ikke fundet",
      description: "Der opstod en fejl ved beregning af resultatet."
    };
  }
  resultHeader.textContent = result.title;
  resultContent.innerHTML = "".concat(result.description, "<br><br>Bestil en professionel skimmelinspektion for en grundig vurdering og l\xF8sning af eventuelle problemer, ved at kontakte os p\xE5 tlf. <a href=\"tel:+4570605563\">70 60 55 63</a> eller via vores hjemmeside.");
}
function resetQuiz() {
  currentQuestionIndex = 0;
  totalScore = 0;
  nextButton.disabled = true;
  resultContainer.classList.add("hidden");
  quizContent.classList.remove("hidden");
  showQuestion();
}
nextButton.addEventListener("click", () => {
  // Get selected answer
  const selectedOption = document.querySelector('input[name="' + QUESTIONS[currentQuestionIndex].id + '"]:checked');
  if (selectedOption) {
    totalScore += Number.parseInt(selectedOption.value);
  }
  currentQuestionIndex++;
  nextButton.disabled = true;

  // console.log("Current Score: " + totalScore);
  if (currentQuestionIndex < QUESTIONS.length) {
    showQuestion();
  } else {
    // Show results
    // console.log("Final Score: " + totalScore);
    showResults();
  }
});
showQuestion();
restartQuiz.addEventListener("click", resetQuiz);
//# sourceMappingURL=quiz.js.map